import * as React from "react";
import shallowCompare = require('react-addons-shallow-compare');

export interface PositionBox {
    top: number;
    left: number;
    bottom: number;
    right: number;
    width: number;
    height: number;
}

/**
 * The `children` prop must be a non-anonymous function when using the
 * `useShallowCompare` flag set to true.
 */
interface SyncPositionProps extends React.Props<SyncPosition> {
    element: HTMLElement;
    useShallowCompare?: boolean;
    position?: string; // absolute|fixed
    children?: (box: PositionBox) => React.ReactElement<any>;
}

interface SyncPositionState extends PositionBox {
}

export default class SyncPosition extends React.Component<SyncPositionProps, SyncPositionState> {
    static defaultProps = {
        position: 'absolute'
    };

    private monitorElementRaf: number;

    constructor(props: SyncPositionProps) {
        super(props);
        this.state = this.getBox();
    }

    render() {
        return this.props.children(this.state);
    }

    componentDidMount() {
        this.monitorElement();
    }

    componentWillUnmount() {
        this.stopMonitorElement();
    }

    shouldComponentUpdate(nextProps: SyncPositionProps, nextState: SyncPositionState) {
        if (this.props.useShallowCompare) {
            return shallowCompare(this, nextProps, nextState);
        } else {
            return true;
        }
    }

    private getBox() {
        const rect = this.props.element.getBoundingClientRect();
        let docRect;

        // Bugfix BUG-4124 overlays are out of sync with content when body has relative position
        // and first element has top margin
        if (document.body.style.position === 'relative') {
            docRect = document.body.getBoundingClientRect();
        } else {
            docRect = document.documentElement.getBoundingClientRect();
        }

        let deltaY = 0;
        let deltaX = 0;

        if (this.props.position === 'absolute') {
            deltaY = - docRect.top;
            deltaX = - docRect.left;
        }

        return {
            top: rect.top + deltaY,
            left: rect.left + deltaX,
            bottom: document.body.offsetHeight - deltaY - rect.bottom,
            right: document.body.offsetWidth - deltaX - rect.right,
            width: rect.width,
            height: rect.height
        };
    }

    private setStateFromElement() {
        const box = this.getBox();
        const stateBox = this.state;

        // Because we call this in a RAF we don't want to do setState
        // unless we are sure something changed
        // TODO compare using general util shallow-compare
        if (
            stateBox.width !== box.width
            || stateBox.height !== box.height
            || stateBox.top !== box.top
            || stateBox.left !== box.left
            || stateBox.right !== box.right
            || stateBox.bottom !== box.bottom
        ) {
            this.setState(box);
        }
    }

    private monitorElement() {
        this.monitorElementRaf = requestAnimationFrame(() => {
            this.setStateFromElement();
            this.monitorElement();
        });
    }

    private stopMonitorElement() {
        cancelAnimationFrame(this.monitorElementRaf);
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/components/SyncPosition.tsx
 **/